<mat-drawer #notesDrawer mode="over" style="position: fixed;height:100%; width:380px;border-radius:0 !important;z-index:10000;overflow:auto !important;" position="end" id="notesDrawer" [(opened)]="vm.isOpen" *ngIf="vm.initialized">
	<div class="c-card" style="height:100%" *ngIf="vm.isOpen">
		<div class="c-content">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
					<button id="closeButton" type="button" class="c-button c-button--icon c-button--tp" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="c-content u-no-pt">
			<form class="c-form" name="vm.form">
				<div class="c-form__group u-osb-lg">
					<label for="{{ 'notes-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Call.Content.Notes' | translate }}</label>
					<textarea name="notes" id="{{ 'notes-' + vm.uid }}" class="c-form__input c-form__input--sm" rows="8" [(ngModel)]="vm.notes.data.notes" (ngModelChange)="onNotesChange($event)"></textarea>
					<p class="c-text c-text--sm c-text--gray u-ost-xs">{{ 'Call.Content.Notes_Stored_Automatically' | translate }}</p>
				</div>
			</form>
		</div>
	</div>
</mat-drawer>
